import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataConclusao = (): TabelaColuna => ({
  Chave: 'dataConclusao',
  Alinhamento: 'center',
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataConclusao)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 120 }}>Data Conclusão</div>
})
